import { WebUrl } from "shared-web/lib/webUrl"

export function adminReconciliation(): WebUrl {
  return {
    pathname: "/admin/reconciliation",
  }
}

export function adminReconciliationDetail(id: string): WebUrl {
  return {
    pathname: `/admin/reconciliation/${id}`,
  }
}
